import config from '../config/common.json';

export class VAT {
  private static legacyValue = 17;
  private static changedValue = 18;
  private static vatChangeDate = new Date(config.vatChangeDate);

  static percents(date = new Date()) {
    return (date < this.vatChangeDate) ? this.legacyValue : this.changedValue;
  }

  static toString(date = new Date()) {
    return `${this.percents(date)}%`;
  }

  static fraction(date = new Date()) {
    return this.percents(date) / 100;
  }
}